export default __webpack_public_path__ + "static/media/spinner-arrow.58d2333a.svg";